const menu = [
  {
    heading: "Tableaux de bord",
  },
  {
    icon: "dashlite",
    text: "Tableau de bord",
    link: "/hse-dashboard",
    permissions: [
      "dashboard.view",
      "dashboard.hse",
      "dashboard.management",
      "Tableau de bord - Voir",
      "Tableau de bord - HSE",
      "Tableau de bord - Management",
    ],
  },
  {
    icon: "grid-alt",
    text: "Pilotage transversal",
    link: "/hse-pilotage",
    permissions: [
      "dashboard.view",
      "dashboard.hse",
      "dashboard.management",
      "Tableau de bord - Voir",
      "Tableau de bord - HSE",
      "Tableau de bord - Management",
    ],
  },
  {
    heading: "Gestion HSE",
  },
  {
    icon: "file-text",
    text: "Observations HSE",
    link: "/observations",
    active: false,
    subMenu: [
      {
        text: "Liste des observations",
        link: "/observations",
        permissions: ["observations.view", "Observations - Voir"],
      },
      {
        text: "Workflow",
        link: "/workflow/observations",
        permissions: ["workflow.view", "Workflow - Voir"],
      },
      {
        text: "Historique",
        link: "/workflow/history",
        permissions: ["workflow.history", "Workflow - Historique"],
      },
      {
        text: "Prédiction de retard",
        link: "/workflow/delay-predictions",
        permissions: ["workflow.view", "Workflow - Voir"],
      },
    ],
    permissions: [
      "observations.view",
      "Observations - Voir",
      "workflow.view",
      "workflow.history",
      "Workflow - Voir",
      "Workflow - Historique",
      "observations.create",
      "Observations - Créer",
    ],
  },
  {
    icon: "notes-alt",
    text: "Processus HSE",
    active: false,
    subMenu: [
      {
        text: "Vue d’ensemble (prévention)",
        link: "/hse-process",
        permissions: [
          "Inspections - Voir",
          "Inspections - Créer",
          "Permis de travail - Voir",
          "Permis de travail - Créer",
          "MOC - Voir",
          "MOC - Créer",
          "Incidents - Voir",
          "Incidents - Créer",
          "Actifs - Voir",
          "Actifs - Créer",
        ],
      },
      {
        text: "Inspections (checklists)",
        link: "/hse-process/inspections",
        permissions: ["Inspections - Voir", "Inspections - Créer"],
      },
      {
        text: "Permis de travail (PTW)",
        link: "/hse-process/permits",
        permissions: ["Permis de travail - Voir", "Permis de travail - Créer"],
      },
      {
        text: "Management of Change (MOC)",
        link: "/hse-process/moc",
        permissions: ["MOC - Voir", "MOC - Créer"],
      },
      {
        text: "Incidents & RCA",
        link: "/hse-process/incidents",
        permissions: ["Incidents - Voir", "Incidents - Créer"],
      },
      {
        text: "Actifs & sécurité",
        link: "/hse-process/assets",
        permissions: ["Actifs - Voir", "Actifs - Créer"],
      },
    ],
    permissions: [
      "Inspections - Voir",
      "Inspections - Créer",
      "Permis de travail - Voir",
      "Permis de travail - Créer",
      "MOC - Voir",
      "MOC - Créer",
      "Incidents - Voir",
      "Incidents - Créer",
      "Actifs - Voir",
      "Actifs - Créer",
    ],
  },
  {
    icon: "star",
    text: "Carte du mois",
    active: false,
    subMenu: [
      {
        text: "Classement",
        link: "/card-of-month",
        permissions: ["card-of-month.view", "Carte du mois - Voir"],
      },
      {
        text: "Configuration scoring",
        link: "/card-of-month/scoring-config",
        permissions: ["Configuration scoring - Voir", "Configuration scoring - Modifier", "Carte du mois - Sélectionner"],
      },
    ],
    permissions: ["card-of-month.view", "Carte du mois - Voir", "Configuration scoring - Voir", "Configuration scoring - Modifier"],
  },
  {
    heading: "Gestion des utilisateurs",
  },
  {
    icon: "users",
    text: "Utilisateurs & Rôles",
    active: false,
    subMenu: [
      {
        text: "Liste des utilisateurs",
        link: "/users/list",
        permissions: ["users.view", "Utilisateurs - Voir"],
      },
      {
        text: "Rôles & Permissions",
        link: "/users/roles",
        permissions: ["roles.view", "permissions.view", "Rôles - Voir", "Permissions - Voir"],
      },
      {
        text: "Attribution par site",
        link: "/users/sites",
        permissions: ["site-assignment.view", "Attribution Sites - Voir"],
      },
      {
        text: "Historique des actions",
        link: "/users/audit",
        permissions: ["activity-logs.view", "Activity Logs - View"],
      },
    ],
    permissions: ["users.view", "roles.view", "site-assignment.view", "activity-logs.view", "Utilisateurs - Voir", "Rôles - Voir", "Attribution Sites - Voir", "Activity Logs - View"],
  },
  {
    icon: "map",
    text: "Sites & Zones",
    link: "/sites",
    permissions: ["sites.view", "Sites - Voir"],
  },
  {
    heading: "Communication",
  },
  {
    icon: "bell",
    text: "Notifications",
    link: "/notifications",
    permissions: ["notifications.view"],
  },
  {
    icon: "alert-circle",
    text: "Centre d'alertes",
    link: "/alerts",
    permissions: ["notifications.view"],
  },
  {
    heading: "Analyses & Rapports",
  },
  {
    icon: "activity",
    text: "IA prédictive",
    link: "/hse-predictive-ai",
    permissions: ["predictive-ai.view", "IA prédictive - Voir"],
  },
  {
    icon: "bar-chart",
    text: "Analytics HSE",
    active: false,
    subMenu: [
      {
        text: "Vue générale",
        link: "/analytics-hse",
        permissions: ["analytics.view", "analytics.hse"],
      },
      {
        text: "Score de risque 7j",
        link: "/analytics/risk-score-7d",
        permissions: ["analytics.view", "analytics.hse"],
      },
    ],
    permissions: ["analytics.view", "analytics.hse"],
  },
  {
    icon: "file-doc",
    text: "Rapports",
    active: false,
    subMenu: [
      {
        text: "Rapports mensuels",
        link: "/reports/monthly",
        permissions: ["reports.view", "reports.monthly"],
      },
      {
        text: "Rapports par site",
        link: "/reports/sites",
        permissions: ["reports.view", "reports.sites"],
      },
      {
        text: "Rapports personnalisés",
        link: "/reports/custom",
        permissions: ["reports.view", "reports.custom"],
      },
    ],
    permissions: ["reports.view", "reports.monthly", "reports.sites", "reports.custom"],
  },
  {
    heading: "Modules Premium",
    badge: "Premium",
  },
  {
    icon: "map-pin",
    text: "Cartographie des risques",
    link: "/risk-mapping",
    badge: "Premium",
    permissions: ["risk-mapping.view"],
  },
  {
    icon: "award",
    text: "Score sécurité HSE",
    active: false,
    subMenu: [
      {
        text: "Classement employés",
        link: "/gamification/leaderboard",
        permissions: ["gamification.view", "gamification.leaderboard"],
      },
      {
        text: "Scores par site",
        link: "/gamification/sites",
        permissions: ["gamification.view", "gamification.leaderboard"],
      },
      {
        text: "Badges",
        link: "/gamification/badges",
        permissions: ["gamification.view", "gamification.badges"],
      },
      {
        text: "Mon score & historique",
        link: "/gamification/points",
        permissions: ["gamification.view", "gamification.points"],
      },
    ],
    permissions: ["gamification.view", "gamification.leaderboard", "gamification.badges", "gamification.points"],
  },
  {
    heading: "Conformité & Audit",
  },
  {
    icon: "shield-check",
    text: "Conformité",
    active: false,
    subMenu: [
      {
        text: "Audit trail",
        link: "/compliance/audit-trail",
        permissions: ["compliance.view", "compliance.audit-trail"],
      },
      {
        text: "Traçabilité",
        link: "/compliance/traceability",
        permissions: ["compliance.view", "compliance.traceability"],
      },
      {
        text: "Rapports d'audit",
        link: "/compliance/audit-reports",
        permissions: ["compliance.view", "compliance.audit-reports"],
      },
      {
        text: "Conformité ISO",
        link: "/compliance/iso",
        permissions: ["compliance.view", "compliance.iso"],
      },
      {
        text: "Assistant conformité intelligent",
        link: "/compliance/intelligent-assistant",
        permissions: ["compliance.view", "compliance.audit-trail", "compliance.iso"],
      },
    ],
    permissions: ["compliance.view", "compliance.audit-trail", "compliance.traceability", "compliance.audit-reports", "compliance.iso"],
  },
  {
    heading: "Aide",
  },
  {
    icon: "book",
    text: "Documentation",
    link: "/documentation",
  },
];

export default menu;

